import React from 'react';
import { useStore } from 'src/stores';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { DateChangeInlineModalContent } from './content';
import { BasicTooltip, Icon, SimpleModal } from '@livable/saas-react-components';
export const DateChangeInlineModal = observer(_ref => {
  var _store$homeDashboardS, _store$homeDashboardS2, _store$homeDashboardS3;
  let trigger = _ref.trigger;
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const defaultTrigger = /*#__PURE__*/React.createElement(BasicTooltip, {
    title: "Update ".concat((_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS !== void 0 && _store$homeDashboardS.companyFeatureSet.isAppfolio ? t('billing start date') : t('residencies_page.enrolled_date_cell').toLocaleLowerCase()),
    placement: "top",
    hideOnMobile: true
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small",
    'custom-attribute': '473-batch-date-change-modal'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "calendar-picker"
  })));
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: trigger || defaultTrigger,
    title: "Update ".concat((_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS2 !== void 0 && _store$homeDashboardS2.companyFeatureSet.isAppfolio ? t('billing start date') : t('residencies_page.enrolled_date_cell').toLocaleLowerCase()),
    subTitle: store.residenciesMultiActionStore.isSelectedIsMultiPropertyView ? store.residenciesMultiActionStore.isSelectedFromSingleProperty ? (_store$homeDashboardS3 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS3 === void 0 || (_store$homeDashboardS3 = _store$homeDashboardS3.propertyDetails(store.residenciesMultiActionStore.selectedDetails[0].propertyId).propertyInformation) === null || _store$homeDashboardS3 === void 0 || (_store$homeDashboardS3 = _store$homeDashboardS3.address) === null || _store$homeDashboardS3 === void 0 ? void 0 : _store$homeDashboardS3.addressString : t('general.residents_are_selected_from_number_of_properties', {
      numberOfProperties: store.residenciesMultiActionStore.selectedPropertyIds.length
    }) : null,
    noFooter: true
  }, /*#__PURE__*/React.createElement(DateChangeInlineModalContent, null));
});